import { render, staticRenderFns } from "./index.vue?vue&type=template&id=13cb2dc9&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=13cb2dc9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cb2dc9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13cb2dc9')) {
      api.createRecord('13cb2dc9', component.options)
    } else {
      api.reload('13cb2dc9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=13cb2dc9&scoped=true&lang=pug", function () {
      api.rerender('13cb2dc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vipMgm/index.vue"
export default component.exports